type Props = {
  message?: string;
};

export function LoadingState({
  message = "Loading...",
}: Props) {
  return (
    <div className="flex h-64 items-center justify-center">
      <p className="text-slate-400">{message}</p>
    </div>
  );
}